import { render, staticRenderFns } from "./IndexInfo.vue?vue&type=template&id=c23e08bc&scoped=true&"
import script from "./IndexInfo.vue?vue&type=script&lang=js&"
export * from "./IndexInfo.vue?vue&type=script&lang=js&"
import style0 from "./IndexInfo.vue?vue&type=style&index=0&id=c23e08bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23e08bc",
  null
  
)

export default component.exports